// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2fKtf","containerBox":"styles_containerBox__2EvQR","boxIcon":"styles_boxIcon__3s_9s","boxMessage":"styles_boxMessage__3NMLh"};